import { useContext } from "react";
import { AuthContextType, AuthContext } from "components/login/ui/AuthProvider";

export const useAuth = (): AuthContextType => {
  return useContext(AuthContext);
};

export default useAuth;
